import React from 'react';
import Chip from './chip';
import getFromDictionary from '../utils/dictionary';
var Chips = function Chips(_ref) {
  var selectedProduct = _ref.selectedProduct,
    selectedDevice = _ref.selectedDevice,
    showDirect = _ref.showDirect,
    selectDeviceDictionary = _ref.selectDeviceDictionary,
    showTwoWayStreaming = _ref.showTwoWayStreaming,
    setSelectedDeviceId = _ref.setSelectedDeviceId,
    setSelectedProductId = _ref.setSelectedProductId,
    setContentLoaded = _ref.setContentLoaded,
    setDirect = _ref.setDirect,
    settings = _ref.settings,
    setTwoWayStreaming = _ref.setTwoWayStreaming,
    setShowIncompatible = _ref.setShowIncompatible,
    showIncompatible = _ref.showIncompatible;
  var resetDropdown = function resetDropdown(id, valueToSelect) {
    var element = document.getElementById(id);
    element.value = valueToSelect;
    if (id === 'devices') {
      setSelectedDeviceId('');
    }
    if (id === 'products') {
      setSelectedProductId(0);
    }
    setContentLoaded(false);
  };
  var clearAll = function clearAll() {
    if (showDirect) {
      setDirect(false);
    }
    if (showTwoWayStreaming) {
      setTwoWayStreaming(false);
    }
    if (showIncompatible) {
      setShowIncompatible(false);
    }
    setSelectedProductId(0);
    setSelectedDeviceId('');
    setContentLoaded(false);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "cg__chips"
  }, selectedProduct && /*#__PURE__*/React.createElement(Chip, {
    value: "".concat(selectedProduct.title, " ").concat(selectedProduct.subTitle),
    onClick: function onClick() {
      return resetDropdown('products', 0);
    }
  }), selectedDevice && /*#__PURE__*/React.createElement(Chip, {
    value: selectedDevice.title,
    onClick: function onClick() {
      return resetDropdown('devices', '');
    }
  }), showDirect && /*#__PURE__*/React.createElement(Chip, {
    value: getFromDictionary('chipDirectStreaming', selectDeviceDictionary),
    onClick: function onClick() {
      return setDirect(false);
    }
  }), showTwoWayStreaming && /*#__PURE__*/React.createElement(Chip, {
    value: getFromDictionary('chipTwoWayStreaming', settings.elements[4]),
    onClick: function onClick() {
      return setTwoWayStreaming(false);
    }
  }), /*#__PURE__*/React.createElement(Chip, {
    value: getFromDictionary('chipClearAll', selectDeviceDictionary),
    onClick: function onClick() {
      return clearAll();
    }
  }));
};
export default Chips;